// src/components/InsiderDefaultProductCard/InsiderDefaultProductCard.tsx
import React from 'react'
import type { ProductType } from 'src/components/product/ProductCard/ProductCardTypes'
import WishlistHeart from 'src/components/ui/WishlistHeart'
import { useWishlistContext } from 'src/contexts/WishlistContext/wishlist-context'
import { InsiderPriceTag } from '../InsiderPriceTag/InsiderPriceTag'
import { sanitizeUrl } from 'src/utils/sanitizeUrl'
import '../styles.scss'

interface Props {
  product: ProductType
  index: number
}

export default function InsiderDefaultProductCard({ product, index }: Props) {
  const { removeProductFromWishlist, addProductToWishlist } =
    useWishlistContext()

  const offer = product.offers?.offers?.[0]
  const wishlistProduct = [{ product }]

  const productUrl = product.slug ?? '#'
  const changeUrl = sanitizeUrl(false, productUrl)

  return (
    <div className="insider-product-card">
      <a href={changeUrl} className="product-link">
        <div
          className="ins-product-box ins-element-link ins-add-to-cart-wrapper ins-sr-api"
          ins-product-id={product.sku ?? 'unknown'}
          event-collection="true"
        >
          <div className="wrappaer-wishlist-image">
            <figure className="product-image">
              <img
                src={product.image?.[0]?.url ?? '/placeholder.png'}
                alt={product.name ?? 'Produto sem nome'}
                loading="lazy"
              />
            </figure>
            <WishlistHeart
              products={[product]}
              hasBackgroundColor={false}
              isOnShelf={false}
              onFilledHeartClick={() =>
                removeProductFromWishlist([product], index)
              }
              onEmptyHeartClick={() => addProductToWishlist(wishlistProduct)}
              pdpPath={`/${product.slug}`}
            />
          </div>

          <div className="product-name">{product.name}</div>
          <InsiderPriceTag listPrice={offer?.listPrice} price={offer?.price} />
        </div>
      </a>
    </div>
  )
}
